export enum DeviceType {
  OURA_RING = 'Oura Ring',
}
